 document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('[data-prevent-autoplay="true"]').forEach(function (section) {
      if (!section) return;

      // Kill autoplay ONLY within this section
      section.querySelectorAll('video-media[autoplay] video').forEach(function(video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.currentTime = 0;
        const parent = video.closest('video-media');
        if (parent) parent.removeAttribute('autoplay');

        video.style.pointerEvents = 'auto';
        video.style.cursor = 'pointer';

        video.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });
      });

      // Play button logic scoped to this section
      section.querySelectorAll('video-media.video-with-play-button').forEach(function(wrapper) {
        const video = wrapper.querySelector('video');
        if (!video) return;

        wrapper.style.position = 'relative';

        const overlay = document.createElement('div');
        overlay.className = 'custom-video-click-overlay';
        wrapper.appendChild(overlay);

        const playBtn = document.createElement('div');
        playBtn.className = 'custom-play-button';
        playBtn.innerHTML = `
          <svg role="presentation" fill="none" focusable="false" class="icon icon-play-button" viewBox="0 0 48 48">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24Zm-3-19.15a.3.3 0 0 0 .462.253l7.545-4.85a.3.3 0 0 0 0-.505l-7.545-4.85a.3.3 0 0 0-.462.252v9.7Z" fill="currentColor"></path>
          </svg>
        `;
        wrapper.appendChild(playBtn);

        let fakeHoverInterval = null;

        const showButton = () => {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
          video.removeAttribute('controls');
        };

        const hideButton = () => {
          playBtn.style.opacity = '0';
          playBtn.style.pointerEvents = 'none';
          video.setAttribute('controls', 'controls');
          video.controls = true;
          video.muted = false;

          if (!fakeHoverInterval) {
            fakeHoverInterval = setInterval(() => {
              video.dispatchEvent(new Event('mousemove'));
            }, 2000);
          }
        };

        const stopFakeHover = () => {
          if (fakeHoverInterval) {
            clearInterval(fakeHoverInterval);
            fakeHoverInterval = null;
          }
        };

        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          video.paused ? video.play() : video.pause();
        });

        overlay.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });

        video.addEventListener('play', hideButton);
        video.addEventListener('pause', () => {
          stopFakeHover();
          showButton();
        });

        video.paused ? showButton() : hideButton();
      });
    });
  }, 400); // slight delay to let Impact's autoplay scripts run first
});



(function () {

  function initMarquees(root = document) {
    root.querySelectorAll('.marquee-text').forEach(marquee => {

      // Prevent double init
      if (marquee.dataset.marqueeInit === 'true') return;
      marquee.dataset.marqueeInit = 'true';

      const marqueeTrack = marquee.querySelector('.marquee-text-track');
      if (!marqueeTrack) return;

      let items = Array.from(marqueeTrack.children);

      if (!items.length) {
        console.warn('No marquee items found.');
        return;
      }

      function startMarquee() {
        let contentWidth = 0;

        // Measure width safely
        items.forEach(item => {
          contentWidth += item.offsetWidth;
        });

        // Bail and retry if layout not ready
        if (contentWidth === 0) {
          setTimeout(startMarquee, 100);
          return;
        }

        const containerWidth = marquee.clientWidth || window.innerWidth;

        // Duplicate until wide enough
        while (contentWidth < containerWidth * 2) {
          items.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeTrack.appendChild(clone);
            contentWidth += clone.offsetWidth;
          });
        }

        const isMobile = window.innerWidth <= 768;
        const scrollDuration = parseFloat(
          marquee.dataset[isMobile ? 'scrollDurationMobile' : 'scrollDurationDesktop']
        ) || 80;

        const pixelsPerSecond = contentWidth / scrollDuration;
        let scrollPosition = 0;

        function animate() {
          scrollPosition -= pixelsPerSecond / 60;

          if (Math.abs(scrollPosition) >= contentWidth / 2) {
            scrollPosition = 0;
          }

          marqueeTrack.style.transform = `translateX(${scrollPosition}px)`;
          requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
      }

      // Ensure fonts + layout are ready
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(startMarquee);
      } else {
        setTimeout(startMarquee, 100);
      }
    });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    initMarquees(document);
  });

  // Theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      initMarquees(e.target);
    });
  }

})();




(function() {
  function refreshAfterpay(amountCents) {
    const el = document.querySelector('square-placement[data-amount]');
    if (!el) return;

    // Update the widget’s data-amount attribute
    el.setAttribute('data-amount', (amountCents / 100).toFixed(2));

    // Re-init Afterpay if possible
    if (window.Afterpay?.initialize) {
      window.Afterpay.initialize();
    } else if (window.Afterpay?.refresh) {
      window.Afterpay.refresh();
    } else if (window.Clearpay?.initialize) {
      window.Clearpay.initialize();
    }
  }

  function getCurrentVariantPrice() {
    const jsonEl = document.querySelector('variant-picker script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      const data = JSON.parse(jsonEl.textContent);
      return data?.price || null;
    } catch(e) {
      console.warn('Could not parse current variant JSON', e);
      return null;
    }
  }

  // Hook into your theme’s event
  window.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (variant) {
      refreshAfterpay(variant.price);
    }
  });

  // Fallback for direct clicks on radios
  document.addEventListener('change', (e) => {
    if (e.target.closest('.variant-picker')) {
      const price = getCurrentVariantPrice();
      if (price) refreshAfterpay(price);
    }
  });

  // Kick it once on load with the current variant price
  document.addEventListener('DOMContentLoaded', () => {
    const price = getCurrentVariantPrice();
    if (price) refreshAfterpay(price);
  });
})();






/***************** SKY VIDEO *****************/

function initSkyVideoSections() {
  document.querySelectorAll(".sky-video-container").forEach(container => {
    if (container.dataset.initialized === "true") return;
    container.dataset.initialized = "true";

    const video = container.querySelector(".sky-video");
    if (!video) return;

    const playButton        = container.querySelector(".sky-video-play-button");
    const muteButton        = container.querySelector(".mute-btn");
    const muteIcon          = muteButton ? muteButton.querySelector("i") : null;
    const progressBar       = container.querySelector(".sky-progress-bar");
    const progressIndicator = container.querySelector(".progress-indicator");
    const fullscreenButton  = container.querySelector(".fullscreen-btn");
    const canvas            = container.querySelector(".video-canvas");
    const ctx               = canvas ? canvas.getContext("2d") : null;

    const autoplayEnabled   = container.dataset.autoplay === "true";
    const loopEnabled       = container.dataset.loop === "true";
    const showMuteButton    = container.dataset.showMute === "true";
    const muteVideo         = container.dataset.mute === "true";
    const showProgressBar   = container.dataset.showProgress === "true";
    const frameCaptureTime  = parseFloat(container.dataset.frameTime) || 1;
    const showExpandButton  = container.dataset.showExpand === "true";
    const videoDimensions   = container.dataset.videoDimensions;
    const preventToggle     = container.dataset.preventToggle === "true";

    // Loop support
    video.loop = loopEnabled;

    // "Original" aspect ratio mode
    if (videoDimensions === "original") {
      video.preload = "metadata";
      video.load();

      video.addEventListener("loadedmetadata", function () {
        let videoWidth = video.videoWidth;
        let videoHeight = video.videoHeight;

        if (videoWidth === 0 || videoHeight === 0) {
          setTimeout(() => {
            videoWidth = video.videoWidth;
            videoHeight = video.videoHeight;
            applyAspectRatio(videoWidth, videoHeight);
          }, 500);
        } else {
          applyAspectRatio(videoWidth, videoHeight);
        }
      });
    }

    video.addEventListener("play", () => {
      const placeholder = container.querySelector(".video-placeholder");
      if (placeholder) placeholder.style.display = "none";
    });

    function applyAspectRatio(width, height) {
      if (width > 0 && height > 0) {
        container.style.aspectRatio = width / height;
      }
    }

    // Fullscreen button visibility + single click handler
    if (!showExpandButton && fullscreenButton) {
      fullscreenButton.style.display = "none";
    } else if (fullscreenButton) {
      fullscreenButton.addEventListener("click", toggleFullscreen);
    }

    // Autoplay behavior
    if (autoplayEnabled) {
      video.setAttribute("autoplay", "true");
      video.muted = true;
      if (playButton) playButton.style.opacity = "0";
    } else {
      video.removeAttribute("autoplay");
    }

    // Hide mute UI if we're forcing mute with no button
    if (muteVideo && !showMuteButton && muteButton) {
      muteButton.style.display = "none";
    }

    function updateMuteIcon() {
      if (!muteIcon) return;
      muteIcon.classList.toggle("fa-volume", !video.muted);
      muteIcon.classList.toggle("fa-volume-slash", video.muted);
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
        if (playButton) playButton.style.opacity = "0";
      } else {
        video.pause();
        if (playButton) playButton.style.opacity = "1";
      }
    }

    function toggleMute() {
      video.muted = !video.muted;
      updateMuteIcon();
    }

    function updateProgressBar() {
      if (!progressIndicator || !video.duration) return;
      const progress = (video.currentTime / video.duration) * 100;
      progressIndicator.style.width = progress + "%";
    }

    function seekVideo(event) {
      if (!progressBar || !video.duration) return;
      const rect = progressBar.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const newTime = (offsetX / rect.width) * video.duration;
      video.currentTime = newTime;
    }

    let isDragging = false;

    function startDrag(event) {
      isDragging = true;
      seekVideo(event);
      document.addEventListener("mousemove", dragSeek);
      document.addEventListener("mouseup", stopDrag);
    }

    function dragSeek(event) {
      if (isDragging) {
        seekVideo(event);
      }
    }

    function stopDrag() {
      isDragging = false;
      document.removeEventListener("mousemove", dragSeek);
      document.removeEventListener("mouseup", stopDrag);
    }

    function toggleFullscreen() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        // Enter fullscreen
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          // iOS Safari
          video.webkitEnterFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        // Exit fullscreen
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    // Sync UI when fullscreen ends
    document.addEventListener("fullscreenchange", forceUIUpdate);
    document.addEventListener("webkitfullscreenchange", forceUIUpdate);

    function forceUIUpdate() {
      document.querySelectorAll(".sky-video-container").forEach(container => {
        const playButton       = container.querySelector(".sky-video-play-button");
        const muteButton       = container.querySelector(".mute-btn");
        const progressBar      = container.querySelector(".sky-progress-bar");
        const fullscreenButton = container.querySelector(".fullscreen-btn");

        const showMuteButton   = container.dataset.showMute === "true";
        const showProgressBar  = container.dataset.showProgress === "true";
        const showExpandButton = container.dataset.showExpand === "true";

        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
          if (playButton) {
            playButton.style.display = "none";
            setTimeout(() => (playButton.style.display = "flex"), 50);
          }

          if (fullscreenButton) {
            fullscreenButton.style.display = "none";
            setTimeout(
              () => (fullscreenButton.style.display = showExpandButton ? "flex" : "none"),
              50
            );
          }

          if (muteButton) {
            muteButton.style.display = "none";
            setTimeout(
              () => (muteButton.style.display = showMuteButton ? "flex" : "none"),
              50
            );
          }

          if (progressBar) {
            progressBar.style.display = "none";
            setTimeout(
              () => (progressBar.style.display = showProgressBar ? "block" : "none"),
              50
            );
          }
        }
      });
    }

    const hasPoster = video.hasAttribute("poster") && video.getAttribute("poster") !== "";

    function captureFrame() {
      try {
        if (!ctx) return;

        if (video.src && video.src.startsWith("http") && new URL(video.src).origin !== location.origin) {
          console.warn("Skipping frame capture due to CORS restrictions.");
          return;
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        video.setAttribute("poster", canvas.toDataURL("image/webp"));
      } catch (error) {
        console.error("Failed to capture video frame:", error);
      }
    }

    if (!hasPoster && canvas) {
      video.addEventListener("loadedmetadata", function () {
        if (video.readyState >= 2) {
          video.currentTime = frameCaptureTime;
        } else {
          console.warn("Skipping seek due to video not being ready.");
        }
      });

      video.addEventListener("seeked", captureFrame);
    }

    // Autoplay + preventToggle: force playing, no toggling
    if (autoplayEnabled && preventToggle) {
      if (playButton) playButton.style.display = "none";
      video.addEventListener("play", () => (video.controls = false));
      video.addEventListener("pause", () => video.play());
    }

    // Click-to-play only when not explicitly prevented
    if (!autoplayEnabled || !preventToggle) {
      if (playButton) playButton.addEventListener("click", togglePlayPause);
      video.addEventListener("click", togglePlayPause);
    }

    video.addEventListener("ended", () => {
      if (playButton) playButton.style.opacity = "1";
    });

    if (muteButton) muteButton.addEventListener("click", toggleMute);

    video.addEventListener("timeupdate", updateProgressBar);
    video.addEventListener("play", updateProgressBar);
    video.addEventListener("seeked", updateProgressBar);

    if (progressBar)       progressBar.addEventListener("mousedown", startDrag);
    if (progressIndicator) progressIndicator.addEventListener("mousedown", startDrag);

    updateMuteIcon();
  });
}

document.addEventListener("DOMContentLoaded", initSkyVideoSections);

if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load",   initSkyVideoSections);
  document.addEventListener("shopify:section:unload", initSkyVideoSections);
}




/*************** COURSE MODULES INIT 

document.addEventListener("DOMContentLoaded", initCourseModules);
document.addEventListener("shopify:section:load", initCourseModules);

function initCourseModules() {
  // ACCORDION BEHAVIOUR
  document.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    const btn   = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        // Closing accordion: stop any videos inside
        btn.setAttribute('aria-expanded', 'false');

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v  = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = "1";
        });

        // Collapse
        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });

      } else {
        // Opening accordion
        btn.setAttribute('aria-expanded', 'true');

        // Expand
        panel.style.maxHeight = inner.scrollHeight + 'px';

        // Initialize videos that appear inside the accordion AFTER it's visible
        setTimeout(() => {
          if (typeof initSkyVideoSections === "function") {
            initSkyVideoSections();
          }
        }, 50);

        panel.addEventListener('transitionend', function handler() {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', handler);
        });
      }
    });
  });

  // CHECKBOX PERSISTENCE
  document.querySelectorAll('.cm-item').forEach(item => {
    const section = item.closest('.cm-section');
    if (!section) return;

    const sectionId  = section.dataset.sectionId;
    const customerId = section.dataset.customerId || 'guest';
    const id         = item.dataset.blockId;

    if (!sectionId || !id) return;

    const key = `cm:${sectionId}:${id}:completed:${customerId}`;

    const box = item.querySelector('.cm-check-input');
    if (!box) return;

    if (localStorage.getItem(key) === '1') box.checked = true;

    box.addEventListener('change', () => {
      if (box.checked) localStorage.setItem(key, '1');
      else localStorage.removeItem(key);
    });
  });
}
***************/


/*************** COURSE MODULES INIT ***************/

document.addEventListener('DOMContentLoaded', initCourseModules);
document.addEventListener('shopify:section:load', initCourseModules);

function initCourseModules(event) {
  const root = event && event.target ? event.target : document;

  // 1. Build collapsible groups from heading blocks
  initCourseModuleGroups(root);

  // 2. Accordion behaviour for module blocks
  initCourseModuleAccordions(root);

  // 3. Checkbox persistence
  initCourseModuleCheckboxes(root);
  initCourseModuleTabs(root);

}

/*************** HEADING GROUPS (FA PLUS/MINUS) ***************/

function initCourseModuleGroups(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    if (section.dataset.cmGroupsInit === 'true') return;
    section.dataset.cmGroupsInit = 'true';

    const list = section.querySelector('.cm-list');
    if (!list) return;

    const children = Array.from(list.children);
    const total = children.length;
    let i = 0;

    while (i < total) {
      const heading = children[i];

      if (!heading.classList.contains('cm-heading-block')) {
        i++;
        continue;
      }

      const collapsible = heading.dataset.collapsible === 'true';
      if (!collapsible) {
        i++;
        continue;
      }

      if (heading.dataset.cmGroupInit === 'true') {
        i++;
        continue;
      }
      heading.dataset.cmGroupInit = 'true';

      const openByDefault = heading.dataset.open === 'true';

      // CREATE GROUP WRAPPER
      const group = document.createElement('div');
      group.className = 'cm-group';

      // Toggle icon container
      const toggle = document.createElement('div');
      toggle.className = 'cm-heading-toggle';
      toggle.innerHTML = `
        <i class="fa-regular fa-plus cm-heading-toggle-icon"></i>
      `;
      heading.appendChild(toggle);

      // Insert group after heading
      if (heading.nextSibling) {
        list.insertBefore(group, heading.nextSibling);
      } else {
        list.appendChild(group);
      }

      // Move modules until next heading
      let j = i + 1;
      while (j < children.length) {
        const node = children[j];
        if (!node) {
          j++;
          continue;
        }
        if (node.classList.contains('cm-heading-block')) break;
        if (node.parentElement === list) group.appendChild(node);
        j++;
      }

      if (!group.children.length) {
        group.remove();
        i = j;
        continue;
      }

      // Initial state
      if (openByDefault) {
        heading.classList.add('is-open');
        group.style.maxHeight = 'none';
      } else {
        heading.classList.add('is-closed-border');
        group.style.maxHeight = '0px';
      }

      updateGroupToggleIcon(heading);

      // Click entire heading
      heading.addEventListener('click', e => {
        const isOpen = heading.classList.contains('is-open');

        if (isOpen) {
          // Close
          group.style.maxHeight = group.scrollHeight + 'px';
          requestAnimationFrame(() => {
            group.style.maxHeight = '0px';
          });
          heading.classList.remove('is-open');
          heading.classList.add('is-closed-border');
        } else {
          // Open
          group.style.maxHeight = group.scrollHeight + 'px';
          heading.classList.add('is-open');
          heading.classList.remove('is-closed-border');

          const handler = () => {
            if (heading.classList.contains('is-open')) {
              group.style.maxHeight = 'none';
            }
            group.removeEventListener('transitionend', handler);
          };
          group.addEventListener('transitionend', handler);
        }

        updateGroupToggleIcon(heading);
      });

      i = j;
    }
  });
}

function updateGroupToggleIcon(heading) {
  const icon = heading.querySelector('.cm-heading-toggle-icon');
  if (!icon) return;

  if (heading.classList.contains('is-open')) {
    icon.classList.remove('fa-plus');
    icon.classList.add('fa-minus');
  } else {
    icon.classList.remove('fa-minus');
    icon.classList.add('fa-plus');
  }
}


/*************** MODULE ACCORDIONS ***************/

function initCourseModuleAccordions(root) {
  root.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    if (item.dataset.cmAccordionInit === 'true') return;
    item.dataset.cmAccordionInit = 'true';

    const btn = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = '1';
        });

        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
      } else {
        btn.setAttribute('aria-expanded', 'true');

        panel.style.maxHeight = inner.scrollHeight + 'px';

        setTimeout(() => {
          if (typeof initSkyVideoSections === 'function') {
            initSkyVideoSections();
          }
        }, 50);

        const onTransitionEnd = () => {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', onTransitionEnd);
        };

        panel.addEventListener('transitionend', onTransitionEnd);
      }
    });
  });
}

/*************** CHECKBOX PERSISTENCE ***************/

function initCourseModuleCheckboxes(root) {
  root.querySelectorAll('.cm-item').forEach(item => {
    if (item.dataset.cmCheckboxInit === 'true') return;
    item.dataset.cmCheckboxInit = 'true';

    const section = item.closest('.cm-section');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const customerId = section.dataset.customerId || 'guest';
    const id = item.dataset.blockId;

    if (!sectionId || !id) return;

    const key = `cm:${sectionId}:${id}:completed:${customerId}`;
    const box = item.querySelector('.cm-check-input');
    if (!box) return;

    if (localStorage.getItem(key) === '1') {
      box.checked = true;
    }

    box.addEventListener('change', () => {
      if (box.checked) {
        localStorage.setItem(key, '1');
      } else {
        localStorage.removeItem(key);
      }
    });
  });
}



/*************** TAB FILTERING ***************/

function initCourseModuleTabs(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    if (section.dataset.cmTabsInit === 'true') return;
    section.dataset.cmTabsInit = 'true';

    const tabs = section.querySelectorAll('.cm-tab');
    const items = section.querySelectorAll('.cm-item');

    if (!tabs.length || !items.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        items.forEach(item => {
          const tabsAttr = item.dataset.tabs || '';

          if (selected === '__all__') {
            item.style.display = '';
            return;
          }

          const tabList = tabsAttr.split(',').filter(Boolean);

          if (tabList.includes(selected)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  });
}
